import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import React, { Dispatch, RefObject } from "react";
import { FormInput } from "../../../lib/workout-form/transformers";
import { Action, FormInputs } from "../../../reducers/workoutReducer";

type Props = {
  dispatch: Dispatch<Action>;
  loading: boolean;
  registrationTime: FormInput;
  handleErrorRefs: RefObject<(() => void)[]>;
};

const RegistrationTimeInput = ({
  dispatch,
  loading,
  registrationTime,
}: Props) => {
  return (
    <FormControl fullWidth>
      <InputLabel id="registration-time-label">Sista registrering</InputLabel>
      <Select
        disabled={loading}
        onChange={(e) =>
          dispatch({
            type: FormInputs.registrationTime,
            payload: e.target.value,
          })
        }
        label="Sista registrering"
        labelId="registration-time-label"
        id="registrationTime"
        value={registrationTime.input}>
        <MenuItem value={0}>Ingen</MenuItem>
        <MenuItem value={1}>1h innan</MenuItem>
        <MenuItem value={2}>2h innan</MenuItem>
        <MenuItem value={6}>6h innan</MenuItem>
        <MenuItem value={12}>12h innan</MenuItem>
        <MenuItem value={24}>24h innan</MenuItem>
        <MenuItem value={48}>48h innan</MenuItem>
      </Select>
    </FormControl>
  );
};

export default RegistrationTimeInput;
